import { render, staticRenderFns } from "./send-phone-dongdong.vue?vue&type=template&id=33416f2e&scoped=true"
import script from "./send-phone-dongdong.vue?vue&type=script&lang=js"
export * from "./send-phone-dongdong.vue?vue&type=script&lang=js"
import style0 from "./send-phone-dongdong.vue?vue&type=style&index=0&id=33416f2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33416f2e",
  null
  
)

export default component.exports